/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';

interface GenesysIconMinimalProps {
  className?: string;
  size?: number;
  fill?: string;
}

export const GenesysIconMinimal = ({
  className,
  size = 32,
  fill = '#ff4f1f',
  ...others
}: GenesysIconMinimalProps) => {
  const intl = useIntl();
  const pxWidth = 15 + 'px';
  const pxHeight = size + 'px';
  return (
    <svg
      className={cx('GenesysIcon', className)}
      viewBox="0 0 484.35 792"
      width={pxWidth}
      height={pxHeight}
      fillRule="evenodd"
      xmlns="http://www.w3.org/2000/svg"
      {...others}>
      <title>{intl.formatMessage(messages.genesys)}</title>
      <g data-name="Group 174">
        <g data-name="Group 173">
          <path
            data-name="Path 45"
            fill={fill}
            d="M402.67,45.54a36.09,36.09,0,0,1,0,72.18h-1.89A35.31,35.31,0,0,1,366.6,83.54,45.36,45.36,0,0,1,376.1,57a34.46,34.46,0,0,1,26.57-11.4m0-45.57a81.71,81.71,0,0,0-3.79,163.36h3.79A81.68,81.68,0,0,0,402.67,0Z"
            transform="translate(0 0)"
          />
        </g>
        <path
          data-name="Path 46"
          fill={fill}
          d="M347.43,573.57a83.57,83.57,0,1,1,0,167.14H258.32a83.57,83.57,0,0,1,0-167.14h89.11m0-55.07H258.32a136.75,136.75,0,1,0,0,273.5h89.11a136.75,136.75,0,1,0,0-273.5Z"
          transform="translate(0 0)"
        />
        <path
          data-name="Path 47"
          fill={fill}
          d="M347.6,252.57a83.58,83.58,0,0,1,0,167.15H136.75a83.58,83.58,0,1,1-.07-167.15H347.57m0-55.07H136.75a136.75,136.75,0,1,0,0,273.5H347.57a136.75,136.75,0,1,0,0-273.5Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};
